import {ChangeDetectionStrategy, Component, EventEmitter, Input, Output} from '@angular/core'
import {NgClass} from '@angular/common'
import {ButtonModule} from '../button/button.module'
import {BehaviorSubject} from 'rxjs'

export type ButtonClickEventArgs = {
  done: () => void
}

@Component({
  selector: 'cft-progressive-disclosure-box',
  templateUrl: './progressive-disclosure-box.component.html',
  styles: [
    `
      @reference '../../../styles/app-reference.css';

      :host {
        @apply block rounded-3 bg-grey-50 text-primary shadow-3;
      }
    `,
  ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [NgClass, ButtonModule],
})
export class ProgressiveDisclosureBoxComponent {
  @Input() heading!: string
  @Input() subHeading?: string
  @Input() buttonText = 'Submit'
  @Output() buttonClicked = new EventEmitter<ButtonClickEventArgs>()

  private readonly loading = new BehaviorSubject<boolean>(false)

  get isLoading$() {
    return this.loading.asObservable()
  }

  buttonClick() {
    this.loading.next(true)
    this.buttonClicked.emit({
      done: () => {
        this.loading.next(false)
      },
    })
  }
}
